<template>
    <div>
        <div class="form-input-datepicker--label">
            <span v-if="label">{{ label }}:</span>
            <span v-if="showInfoTip">
                <common-info-tip :containerDimensions="containerDimensions">
                    <span>{{ infoTipMessage }}</span>
                </common-info-tip>
            </span>
        </div>
        <div class="form-input-datepicker">
            <datepicker
                ref="datepicker"
                v-model="selected"
                inputFormat="dd-MM-yyyy"
                :placeholder="placeholder"
                :upperLimit="upperLimit"
                :lowerLimit="lowerLimit"
                :clearable="true"
                class="form-input-datepicker__input"
            >
                <template #clear="{ onClear }">
                    <div class="form-input-datepicker__close" @click="onClear">
                        <common-icon name="close" size="tiny"></common-icon>
                    </div>
                </template>
            </datepicker>
        </div>
        <span v-if="errorMessage" class="form-input-text--error">{{ errorMessage }}</span>
    </div>
</template>

<script>
    import Datepicker from 'vue3-datepicker'
    import FormInputMixin from 'mixins/FormInputMixin'
    import dayjs from 'dayjs'
    import { dateFormat } from '~/helpers'

    export default {
        mixins: [FormInputMixin],

        components: {
            Datepicker,
        },

        props: {
            upperLimit: { type: String, default: null },
            lowerLimit: { type: String, default: null },
            showInfoTip: { type: Boolean, default: false },
            infoTipMessage: { type: String, default: '' },
            prefillValue: { type: String, default: undefined },
            containerDimensions: { type: Object, default: undefined },
        },

        data() {
            return {
                selected: null,
                payload: undefined,
            }
        },

        watch: {
            selected() {
                document.activeElement.blur()

                this.emitEvent({
                    name: 'date-changed',
                    payload: this.selected ? dayjs(this.selected).format('YYYY-MM-DD') : undefined,
                })
            },

            '$route.params.type': {
                handler: function () {
                    this.$refs.datepicker.clearModelValue()
                },
            },

            prefillValue() {
                if (this.prefillValue) {
                    this.selected = dateFormat(this.prefillValue)
                }
            },
        },

        mounted() {
            if (this.prefillValue) {
                this.selected = dateFormat(this.prefillValue)
            }
        },
    }
</script>
